import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { breakpoints, useMediaQuery } from "@tvg/design-system";
import { Header, Icon, LinkCard } from "@tvg/design-system/web";
import { getHandicappingInfoPromos } from "../../redux/selectors";
import { HandicappingSectionItems } from "../../types";
import { IconContainer, HeaderContainer, Section } from "./styled-components";

const HandicappingSection = ({ isFromHomePage = false }) => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery(breakpoints.tablet.max.sm);
  const handicappingContent: HandicappingSectionItems = useSelector(
    getHandicappingInfoPromos
  );

  if (!handicappingContent) return null;

  return (
    <Section isFromHomePage={isFromHomePage} isMobile={isMobile}>
      <HeaderContainer isMobile={isMobile}>
        <Header tag="h3" color="--fd-colors-content-strong">
          {handicappingContent.title}
        </Header>
      </HeaderContainer>

      {handicappingContent.items?.map((item, i) => (
        <LinkCard
          key={item.title}
          title={item.title}
          description={item.description}
          startContent={
            <Icon
              name={item.iconLeft}
              size="s"
              lineColor="--fd-colors-content-default"
              marginRight={8}
              marginLeft={4}
              paddingTop={2}
            />
          }
          endContent={
            <IconContainer>
              <Icon
                name={item.iconRight}
                size="s"
                lineColor="--fd-colors-component-button-tertiary-content-base"
              />
            </IconContainer>
          }
          onPress={() => navigate(item.path)}
          qaLabel={`${i}-LinkCard`}
          isLinkItem
          alignStart
        />
      ))}
    </Section>
  );
};

export default HandicappingSection;
